<template>
  <header
    class="site-header"
    :class="{
      'is-scrolled': isScrolled,
      'is-top': !isScrolled,
      'menu-open': mobileMenuOpen
    }"
  >
    <div class="header-container container">
      <!-- Logo -->
      <router-link to="/" class="logo" @click.native="closeMenu">
        <span class="logo-mark" aria-hidden="true"></span>
        <span class="logo-wordmark">
          <span class="logo-text">Amiluma</span>
        </span>
      </router-link>

      <!-- 桌面端导航 -->
      <nav class="nav-menu">
        <ul class="nav-list">
          <li class="nav-item" :class="{ active: isActive('/') }">
            <router-link to="/" class="nav-link" exact>首页</router-link>
          </li>
          <li class="nav-item nav-dropdown" :class="{ active: isActive('/products'), 'is-open': productsMenuOpen }">
            <button
              type="button"
              class="nav-link nav-link-dropdown"
              aria-controls="products-submenu"
              :aria-expanded="productsMenuOpen ? 'true' : 'false'"
              @click="toggleProductsMenu"
              @keydown.down.prevent="openProductsMenu"
              @keydown.esc="closeProductsMenu"
            >产品介绍<svg class="dropdown-arrow" width="10" height="10" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5"><polyline points="6 9 12 15 18 9"></polyline></svg></button>
            <div class="dropdown-wrapper">
              <ul id="products-submenu" class="dropdown-menu">
                <li :class="{ active: isActive('/products/children') }"><router-link to="/products/children" class="dropdown-link"><span class="dropdown-dot" aria-hidden="true"></span>Lumi</router-link></li>
                <li :class="{ active: isActive('/products/youth') }"><router-link to="/products/youth" class="dropdown-link"><span class="dropdown-dot" aria-hidden="true"></span>Mellow</router-link></li>
                <li :class="{ active: isActive('/products/elderly') }"><router-link to="/products/elderly" class="dropdown-link"><span class="dropdown-dot" aria-hidden="true"></span>Haven</router-link></li>
              </ul>
            </div>
          </li>
          <li class="nav-item" :class="{ active: isActive('/technology') }"><router-link to="/technology" class="nav-link">技术引擎</router-link></li>
          <li class="nav-item" :class="{ active: isActive('/about') }"><router-link to="/about" class="nav-link">关于我们</router-link></li>
          <li class="nav-item" :class="{ active: isActive('/news') }"><router-link to="/news" class="nav-link">新闻动态</router-link></li>
          <li class="nav-item" :class="{ active: isActive('/cooperation') }"><router-link to="/cooperation" class="nav-link">商务合作</router-link></li>
        </ul>
      </nav>

      <!-- 汉堡按钮 -->
      <button
        type="button"
        class="hamburger"
        :class="{ open: mobileMenuOpen }"
        @click.stop="toggleMenu"
        aria-label="菜单"
      >
        <span></span>
        <span></span>
        <span></span>
      </button>
    </div>

    <!-- 遮罩层 -->
    <div
      v-show="mobileMenuOpen"
      class="menu-overlay"
      @click="closeMenu"
    ></div>

    <!-- 移动端抽屉菜单 -->
    <nav v-show="mobileMenuOpen" class="mobile-nav">
      <div class="mobile-nav-inner">
        <ul class="mobile-nav-list">
          <li :class="{ active: isActive('/') }"><router-link to="/" @click.native="closeMenu" exact>首页</router-link></li>
          <li class="mobile-section-label"><span class="mobile-sub-title">产品介绍</span></li>
          <li class="sub-item" :class="{ active: isActive('/products/children') }"><router-link to="/products/children" @click.native="closeMenu">Lumi</router-link></li>
          <li class="sub-item" :class="{ active: isActive('/products/youth') }"><router-link to="/products/youth" @click.native="closeMenu">Mellow</router-link></li>
          <li class="sub-item" :class="{ active: isActive('/products/elderly') }"><router-link to="/products/elderly" @click.native="closeMenu">Haven</router-link></li>
          <li :class="{ active: isActive('/technology') }"><router-link to="/technology" @click.native="closeMenu">技术引擎</router-link></li>
          <li :class="{ active: isActive('/about') }"><router-link to="/about" @click.native="closeMenu">关于我们</router-link></li>
          <li :class="{ active: isActive('/news') }"><router-link to="/news" @click.native="closeMenu">新闻动态</router-link></li>
          <li :class="{ active: isActive('/cooperation') }"><router-link to="/cooperation" @click.native="closeMenu">商务合作</router-link></li>
        </ul>
      </div>
    </nav>
  </header>
</template>

<script>
export default {
  name: 'SiteHeader',
  data() {
    return {
      isScrolled: false,
      mobileMenuOpen: false,
      productsMenuOpen: false,
      currentPath: ''
    }
  },
  watch: {
    $route: {
      immediate: true,
      handler(to) {
        this.currentPath = to.path
        this.closeMenu()
      }
    }
  },
  mounted() {
    window.addEventListener('scroll', this.handleScroll, { passive: true })
  },
  beforeDestroy() {
    window.removeEventListener('scroll', this.handleScroll)
    document.body.style.overflow = ''
  },
  methods: {
    handleScroll() {
      this.isScrolled = window.pageYOffset > 40
    },
    isActive(path) {
      if (!path) return false
      if (path === '/') return this.currentPath === '/'
      return this.currentPath.startsWith(path)
    },
    toggleMenu() {
      this.mobileMenuOpen = !this.mobileMenuOpen
      document.body.style.overflow = this.mobileMenuOpen ? 'hidden' : ''
    },
    toggleProductsMenu() {
      this.productsMenuOpen = !this.productsMenuOpen
    },
    openProductsMenu() {
      this.productsMenuOpen = true
    },
    closeProductsMenu() {
      this.productsMenuOpen = false
    },
    closeMenu() {
      this.mobileMenuOpen = false
      this.closeProductsMenu()
      document.body.style.overflow = ''
    }
  }
}
</script>

<style lang="scss" scoped>
// ============================================
// Header — Glass Morphism + Editorial Luxury
// ============================================

$header-transition: 0.4s cubic-bezier(0.16, 1, 0.3, 1);
$header-height-scrolled: 64px;

.site-header {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  z-index: $z-index-header;
  height: $header-height;
  transition: height $header-transition, background-color $header-transition, box-shadow $header-transition, backdrop-filter $header-transition;

  // Top of page — floating, transparent
  &.is-top {
    background-color: rgba(255, 250, 242, 0.94);
    backdrop-filter: none;
    border-bottom: 2px solid #2b1a12;

    .logo-mark {
      background: #ff7c26;
    }

    .nav-link {
      color: $color-text;
      text-shadow: none;
    }

    .hamburger span {
      background-color: $color-text;
    }
  }

  // Scrolled — frosted glass
  &.is-scrolled {
    height: $header-height-scrolled;
    background-color: rgba(255, 250, 242, 0.96);
    backdrop-filter: saturate(180%) blur(20px);
    -webkit-backdrop-filter: saturate(180%) blur(20px);
    border-bottom: 2px solid #2b1a12;
    box-shadow: 0 6px 0 rgba(43, 26, 18, 0.08);

    .logo-mark {
      background: #ff7c26;
    }

    .logo-text {
      color: $color-primary;
    }

    .nav-link {
      color: $color-text;
    }

    .hamburger span {
      background-color: $color-text;
    }
  }

  // Menu open override — always opaque
  &.menu-open {
    background-color: rgba(255, 250, 242, 0.98);
    backdrop-filter: saturate(180%) blur(20px);
    -webkit-backdrop-filter: saturate(180%) blur(20px);
    box-shadow: none;

    .hamburger span { background-color: $color-text; }
    .nav-link { color: $color-text; }
  }

  @include mobile-only {
    height: $header-height-mobile;

    &.is-scrolled {
      height: 56px;
    }
  }
}

.header-container {
  @include flex-between;
  height: 100%;
}

// ========== Logo ==========
.logo {
  display: flex;
  align-items: center;
  gap: 12px;
  z-index: $z-index-header + 1;
  text-decoration: none;
  flex-shrink: 0;
}

.logo-mark {
  display: block;
  width: 14px;
  height: 14px;
  border: 2px solid #2b1a12;
  border-radius: 4px;
  transform: rotate(45deg);
  transition: background-color $header-transition, transform 0.6s cubic-bezier(0.16, 1, 0.3, 1);
  flex-shrink: 0;
}

.logo:hover .logo-mark {
  transform: rotate(225deg);
}

.logo-wordmark {
  display: flex;
  align-items: baseline;
}

.logo-text {
  font-family: $font-family-en;
  font-size: 26px;
  font-weight: $font-weight-bold;
  color: #7e4c31;
  letter-spacing: 0;
  margin-right: 6px;
  transition: color $header-transition, font-size $header-transition;

  .is-scrolled & {
    font-size: 23px;
  }
}

// ========== Desktop Navigation ==========
.nav-menu {
  display: flex;
  align-items: center;
  height: 100%;

  @include tablet-only { display: none; }
  @include mobile-only { display: none; }
}

.nav-list {
  display: flex;
  align-items: center;
  height: 100%;
  gap: 12px;
  list-style: none;
  margin: 0;
  padding: 0;
}

.nav-item {
  position: relative;
  height: 100%;
  display: flex;
  align-items: center;
}

.nav-link {
  position: relative;
  display: inline-flex;
  align-items: center;
  gap: 4px;
  padding: 8px 18px;
  font-size: 16px;
  font-weight: $font-weight-semibold;
  color: $color-text;
  text-decoration: none;
  white-space: nowrap;
  cursor: pointer;
  border-radius: $radius-full;
  border: 0;
  background: transparent;
  font-family: inherit;
  transition: color 0.3s ease, background-color 0.3s ease;
  letter-spacing: 1px;

  // Active pill background
  .nav-item.active > & {
    color: #7e4c31;
    background-color: #fff3df;
    box-shadow: inset 0 0 0 2px rgba(43, 26, 18, 0.12);
  }

  &:hover,
  &:focus-visible {
    color: #ef3d2f;
    background-color: #fff3df;
  }

  // Router link active states
  &.router-link-exact-active,
  &.router-link-active {
    color: #7e4c31;
    background-color: #fff3df;
    box-shadow: inset 0 0 0 2px rgba(43, 26, 18, 0.12);
  }
}

// ========== Dropdown ==========
.nav-dropdown {
  .nav-link-dropdown {
    .dropdown-arrow {
      transition: transform 0.3s cubic-bezier(0.16, 1, 0.3, 1);
      opacity: 0.5;
    }
  }

  &:hover,
  &:focus-within,
  &.is-open {
    .dropdown-arrow {
      transform: rotate(180deg);
      opacity: 1;
    }

    .dropdown-wrapper {
      opacity: 1;
      visibility: visible;
      pointer-events: auto;
    }

    .dropdown-menu {
      transform: translateY(0);
      opacity: 1;
    }
  }

  &.active > .nav-link-dropdown {
    color: #7e4c31;
    background-color: #fff3df;
    box-shadow: inset 0 0 0 2px rgba(43, 26, 18, 0.12);
  }
}

.dropdown-wrapper {
  position: absolute;
  top: calc(100% - 2px);
  left: 50%;
  transform: translateX(-50%);
  padding-top: 8px;
  opacity: 0;
  visibility: hidden;
  pointer-events: none;
  transition: opacity 0.3s ease, visibility 0.3s ease;
}

.dropdown-menu {
  position: relative;
  background-color: rgba(255, 250, 242, 0.98);
  backdrop-filter: saturate(180%) blur(20px);
  -webkit-backdrop-filter: saturate(180%) blur(20px);
  border: 2px solid #2b1a12;
  border-radius: 16px;
  box-shadow: 6px 7px 0 rgba(43, 26, 18, 0.16);
  min-width: 180px;
  padding: 6px;
  transform: translateY(4px);
  opacity: 0;
  transition: transform 0.35s cubic-bezier(0.16, 1, 0.3, 1), opacity 0.25s ease;
  list-style: none;
  margin: 0;

  li {
    padding: 0;
    border-radius: 8px;
    overflow: hidden;

    &.active .dropdown-link {
      color: #ef3d2f;
      background-color: #fff3df;
    }
  }
}

.dropdown-link {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 11px 20px;
  font-size: 16px;
  font-weight: $font-weight-semibold;
  color: $color-text;
  text-decoration: none;
  transition: all 0.2s ease;
  white-space: nowrap;
  border-radius: 6px;

  &:hover {
    color: #ef3d2f;
    background-color: #fff3df;
  }
}

.dropdown-dot {
  display: block;
  width: 5px;
  height: 5px;
  border-radius: 50%;
  background-color: #ff7c26;
  flex-shrink: 0;
  opacity: 0;
  transform: scale(0);
  transition: all 0.25s cubic-bezier(0.16, 1, 0.3, 1);

  .dropdown-link:hover &,
  li.active & {
    opacity: 1;
    transform: scale(1);
  }
}

// ========== Hamburger ==========
.hamburger {
  display: none;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  width: 44px;
  height: 44px;
  padding: 0;
  margin: 0;
  background: transparent;
  border: none;
  cursor: pointer;
  gap: 5px;
  -webkit-tap-highlight-color: transparent;
  -webkit-appearance: none;
  appearance: none;
  outline: none;
  z-index: $z-index-header + 3;

  @include tablet-only { display: flex; }
  @include mobile-only { display: flex; }

  span {
    display: block;
    width: 22px;
    height: 2px;
    background-color: $color-text;
    border-radius: 2px;
    transition: all 0.35s cubic-bezier(0.16, 1, 0.3, 1);
    transform-origin: center;
    pointer-events: none;
  }

  &.open {
    span:nth-child(1) {
      transform: translateY(7px) rotate(45deg);
    }
    span:nth-child(2) {
      opacity: 0;
      transform: scaleX(0);
    }
    span:nth-child(3) {
      transform: translateY(-7px) rotate(-45deg);
    }
  }
}

// ========== Overlay ==========
.menu-overlay {
  position: fixed;
  inset: 0;
  background-color: rgba(0, 0, 0, 0.35);
  backdrop-filter: blur(4px);
  -webkit-backdrop-filter: blur(4px);
  z-index: $z-index-header + 1;
  animation: overlay-in 0.35s ease both;
}

@keyframes overlay-in {
  from { opacity: 0; }
  to   { opacity: 1; }
}

// ========== Mobile Drawer ==========
.mobile-nav {
  position: fixed;
  top: 0;
  right: 0;
  width: 320px;
  height: 100vh;
  background-color: rgba(255, 255, 255, 0.98);
  backdrop-filter: saturate(180%) blur(30px);
  -webkit-backdrop-filter: saturate(180%) blur(30px);
  z-index: $z-index-header + 2;
  overflow-y: auto;
  border-left: 1px solid rgba(139, 115, 85, 0.06);
  animation: drawer-in 0.4s cubic-bezier(0.16, 1, 0.3, 1) both;

  @include mobile-only {
    width: 100%;
    border-left: none;
  }
}

@keyframes drawer-in {
  from {
    transform: translateX(100%);
    opacity: 0;
  }
  to {
    transform: translateX(0);
    opacity: 1;
  }
}

.mobile-nav-inner {
  padding: calc(#{$header-height} + 32px) 36px 48px;

  @include mobile-only {
    padding: calc(#{$header-height-mobile} + 28px) 28px 48px;
  }
}

.mobile-nav-list {
  list-style: none;
  margin: 0;
  padding: 0;

  > li:not(.mobile-section-label):not(.sub-item) {
    border-bottom: 1px solid rgba(139, 115, 85, 0.06);

    > a {
      display: block;
      padding: 18px 0;
      font-size: 18px;
      font-weight: $font-weight-semibold;
      color: $color-text;
      text-decoration: none;
      transition: color 0.2s ease, padding-left 0.3s ease;
      letter-spacing: 0.3px;

      &:hover,
      &:active {
        color: $color-primary;
        padding-left: 4px;
      }
    }

    &.active > a {
      color: $color-primary;
    }
  }

  .mobile-section-label {
    border-bottom: none;
    padding-top: 8px;

    &:first-child {
      padding-top: 0;
    }
  }

  .mobile-sub-title {
    display: block;
    padding: 20px 0 8px;
    font-size: 12px;
    font-weight: $font-weight-semibold;
    color: $color-text-light;
    text-transform: uppercase;
    letter-spacing: 2.5px;
    border-bottom: 1px solid rgba(139, 115, 85, 0.08);
  }

  .sub-item {
    border-bottom: none;

    a {
      display: block;
      padding: 12px 0 12px 16px;
      font-size: 16px;
      font-weight: $font-weight-medium;
      color: $color-text-secondary;
      text-decoration: none;
      transition: color 0.2s ease, padding-left 0.3s ease;
      border-left: 2px solid transparent;

      &:hover,
      &:active {
        color: $color-primary;
        padding-left: 20px;
        border-left-color: rgba($color-primary, 0.2);
      }
    }

    &.active a {
      color: $color-primary;
      border-left-color: $color-primary;
    }
  }
}
</style>
